<template>
  <div>
    <div class="main_wrapper">
      <Spin size="large" fix v-if="loading"></Spin>
      <section class="main">
        <Row :gutter="40" v-for="(list, index) in lives" :key="index">
          <i-col span="24">
            <div class="tooltip">
              <span class="tooltip_title">{{list.timeNodeDesc}}</span>
            </div>
            <Row :gutter="20">
              <i-col span="8" v-for="live in list.courseLists" :key="live.id">
                <Card :bordered="false" :padding="0">
                  <div @click="goLiveDetail(live)">
                    <img class="cover" :src="live.cover"/>
                    <p class="title">{{live.goldenWord || live.title}}</p>
                    <div class="text">
                      <p class="sub_title">
                        <Icon type="md-time" />
                        <span>{{live.expectStartTime | Date('{h}:{i}')}}</span>
                        <span> - {{(live.expectStartTime + live.expectTime) | Date('{h}:{i}')}}</span>
                      </p>
                      <div>
                        <VuiButton :class="['btn', {'disable': !live.enable}]" type="warning" @click="goLiveDetail(live)">
                          <Icon type="md-lock" />
                          <span>加入课程</span>
                        </VuiButton>
                      </div>
                    </div>
                    <div class="state_tooltip" v-if="live.state === COURSE_STATE.LIVING">直播中</div>
                  </div>
                </Card>
              </i-col>
            </Row>
          </i-col>
        </Row>
      </section>
      <div v-if="!loading && lives.length === 0" class="no-course-tip">
        <vui-ico class="ico ibang-schedule" :w="128"></vui-ico>
        <p class="title">精彩课程，敬请期待</p>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState } from 'vuex'
import api from '@/api/course'
import sensorHelp from '@/vendor/sensors/help'
import { LIVE_LIST_VISIT } from '@/constant/sensorEvent'
import { COURSE_STATE } from '@/constant/constants'
export default {
  data () {
    return {
      lives: [],
      loading: false,
      COURSE_STATE,
    }
  },
  computed: {
    ...mapState('app', ['isLogin']),
  },
  mounted () {
    this.getHomeList()
    sensorHelp.track(LIVE_LIST_VISIT)
  },
  methods: {
    async getHomeList () {
      this.loading = true
      this.lives = await api.getHomeList().finally(() => {
        this.loading = false
      })
    },
    goLiveDetail (obj) {
      if (obj.enable) {
        this.$router.push(`/detail/${obj.pkid}`)
      } else {
        if (this.isLogin) {
          this.$store.commit('app/setDrainagePopVisible', { flag: true, enableSign: obj.enableSign })
        } else {
          this.$Message.error('请先登录')
          this.$router.push({ name: 'Login' })
        }
      }
    },
    cancelSignUp (live) {

    },
    signUp (live) {

    },
  },
}
</script>
<style lang="scss" scoped>
@import '@/styles/list.scss'
</style>
